import React, { useState } from "react"
import { FlatList, View } from "react-native"
import { useCommunityEvents } from "@/queries/events"
import EventCard from "./components/EventCard"
import EventsFooter from "./components/EventsFooter"
import { LoadingState } from "./components/EventsStates"
import EmptyState from "./components/EmptyState"
import EventDetailSheet from "./components/EventDetailSheet"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import { H1 } from "@/components/standard/BFText"
import type { CommunityEventFragment } from "@/generated/graphql"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { useViewedCallback } from "@/analytics/react"
import {
  eventCardClicked,
  eventsScreenViewed,
} from "@/analytics/events/communityEvents"

export default function EventsScreen() {
  const { data: events, isLoading } = useCommunityEvents()
  const [selectedEvent, setSelectedEvent] =
    useState<CommunityEventFragment | null>(null)
  const [sheetVisible, setSheetVisible] = useState(false)
  const insets = useSafeAreaInsets()

  const handleEventPress = (event: CommunityEventFragment) => {
    setSelectedEvent(event)
    setSheetVisible(true)
  }

  const handleCloseSheet = () => {
    setSheetVisible(false)
  }

  useViewedCallback(() => {
    if (events) {
      eventsScreenViewed({ eventCount: events.length })
    }
  }, [events])

  if (isLoading) {
    return (
      <BFScreen header={<H1>Events</H1>}>
        <LoadingState />
      </BFScreen>
    )
  }

  return (
    <BFScreen noBackButton={true} ignoreTopSafeArea={false}>
      <View className="p-5" style={{ paddingTop: 20 + insets.top }}>
        <H1>Events</H1>
      </View>
      <View className={"flex-1"}>
        {events?.length === 0 ? (
          <EmptyState />
        ) : (
          <FlatList
            data={events}
            keyExtractor={(item) => item.id}
            renderItem={({ item }) => (
              <EventCard
                event={item}
                onPress={() => {
                  eventCardClicked({
                    eventName: item.name,
                    eventLocation: item.market?.slug || "virtual",
                  })
                  handleEventPress(item)
                }}
              />
            )}
            contentContainerStyle={{
              paddingHorizontal: 20,
              paddingTop: 20,
              paddingBottom: 100, // Add bottom padding for tab bar
            }}
            showsVerticalScrollIndicator={false}
            ListFooterComponent={
              (events?.length || 0) > 0 ? <EventsFooter /> : null
            }
          />
        )}
      </View>

      <EventDetailSheet
        visible={sheetVisible}
        event={selectedEvent}
        onClose={handleCloseSheet}
      />
    </BFScreen>
  )
}
